module.exports = __webpack_public_path__ + "static/media/ab956d19-7e42-4da4-b0be-7e64d554b081.ea362a94.woff";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/ab956d19-7e42-4da4-b0be-7e64d554b081.woff
// module id = 75
// module chunks = 0